<template>
  <div class="form-page-container">
    <div class="page-header">
      <h2>外贸报价单</h2>
      <p class="tips">填写报价信息，生成正式报价单，支持打印导出</p>
    </div>

    <div class="btn-top-group">
      <el-button @click="mode='edit'" :type="mode==='edit'?'primary':''">编辑模式</el-button>
      <el-button @click="mode='view'" :type="mode==='view'?'primary':''">查看模式</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportExcel">导出Excel</el-button>
      <el-button type="danger" icon="el-icon-document" @click="exportPdf">导出PDF</el-button>
      <el-button type="warning" icon="el-icon-qrcode" @click="showQrCode=true">生成二维码</el-button>
    </div>

    <el-form
      ref="quotationForm"
      :model="quotationForm"
      :rules="rules"
      label-width="120px"
      class="custom-form"
      :disabled="mode==='view'"
    >
      <el-card shadow="hover" class="form-card">
        <div slot="header" class="card-title">报价信息</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="报价单号" prop="quoteNo">
              <el-input v-model="quotationForm.quoteNo" placeholder="自动生成/手动填写" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户公司" prop="customerCompany">
              <el-input v-model="quotationForm.customerCompany" placeholder="请输入客户公司" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报价日期" prop="quoteDate">
              <el-date-picker
                v-model="quotationForm.quoteDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效日期" prop="validDate">
              <el-date-picker
                v-model="quotationForm.validDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款方式" prop="payType">
              <el-select v-model="quotationForm.payType" placeholder="请选择" clearable>
                <el-option label="T/T" value="T/T" />
                <el-option label="L/C" value="L/C" />
                <el-option label="D/P" value="D/P" />
                <el-option label="西联汇款" value="Western Union" />
                <el-option label="PayPal" value="PayPal" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输方式" prop="transportType">
              <el-select v-model="quotationForm.transportType" placeholder="请选择" clearable>
                <el-option label="海运" value="Sea" />
                <el-option label="空运" value="Air" />
                <el-option label="快递" value="Express" />
                <el-option label="陆运" value="Land" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="报价人" prop="quoteUser">
              <el-input v-model="quotationForm.quoteUser" placeholder="请填写报价人" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <el-card shadow="hover" class="form-card mt20">
        <div slot="header" class="card-title">
          <span>报价商品</span>
          <el-button v-if="mode==='edit'" type="primary" size="mini" icon="el-icon-plus" @click="addProduct">新增商品</el-button>
        </div>
        <el-table
          :data="quotationForm.productList"
          border
          style="width:100%"
          header-cell-class-name="table-header"
        >
          <el-table-column label="序号" type="index" width="60" align="center" />
          <el-table-column label="产品名称" min-width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productName" placeholder="必填" :disabled="mode==='view'" />
            </template>
          </el-table-column>
          <el-table-column label="型号" min-width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.model" :disabled="mode==='view'" />
            </template>
          </el-table-column>
          <el-table-column label="数量" width="100">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.quantity" :min="1" width="100%" :disabled="mode==='view'" />
            </template>
          </el-table-column>
          <el-table-column label="单价(USD)" min-width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" placeholder="必填" :disabled="mode==='view'" />
            </template>
          </el-table-column>
          <el-table-column label="总价(USD)" min-width="120">
            <template slot-scope="scope">
              <span>{{ (scope.row.quantity * scope.row.unitPrice || 0).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" type="textarea" :rows="1" :disabled="mode==='view'" />
            </template>
          </el-table-column>
          <el-table-column v-if="mode==='edit'" label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="deleteProduct(scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="total-price">
          总报价（USD）：<span class="num">${ totalPrice.toFixed(2) }</span>
        </div>
      </el-card>

      <el-card shadow="hover" class="form-card mt20">
        <div slot="header" class="card-title">报价说明</div>
        <el-form-item label="备注">
          <el-input v-model="quotationForm.remark" type="textarea" :rows="4" placeholder="请填写报价说明" :disabled="mode==='view'" />
        </el-form-item>
      </el-card>

      <div class="btn-box" v-if="mode==='edit'">
        <el-button @click="resetForm">重置</el-button>
        <el-button type="success" icon="el-icon-printer" @click="printForm">打印报价单</el-button>
        <el-button type="primary" icon="el-icon-check" @click="submitForm">确认生成报价单</el-button>
      </div>
    </el-form>

    <el-dialog title="报价单二维码" :visible.sync="showQrCode" width="300px" center>
      <div class="qr-box">
        <canvas id="qrCanvas" ref="qrCanvas"></canvas>
        <p>扫码查看报价单</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import html2pdf from 'html2pdf.js'
import QRCode from 'qrcode'

export default {
  name: 'QuotationForm',
  data() {
    return {
      mode: 'edit',
      showQrCode: false,
      quotationForm: {
        quoteNo: '',
        customerCompany: '',
        quoteDate: '',
        validDate: '',
        payType: '',
        transportType: '',
        quoteUser: '',
        remark: '',
        productList: [
          { productName: '', model: '', quantity: 1, unitPrice: '', remark: '' }
        ]
      },
      rules: {
        quoteNo: [{ required: true, message: '请填写报价单号', trigger: 'blur' }],
        customerCompany: [{ required: true, message: '请填写客户公司', trigger: 'blur' }],
        quoteDate: [{ required: true, message: '请选择报价日期', trigger: 'change' }],
        validDate: [{ required: true, message: '请选择有效日期', trigger: 'change' }],
        quoteUser: [{ required: true, message: '请填写报价人', trigger: 'blur' }]
      }
    }
  },
  computed: {
    totalPrice() {
      return this.quotationForm.productList.reduce((sum, item) => {
        return sum + (item.quantity * item.unitPrice || 0)
      }, 0)
    }
  },
  watch: {
    showQrCode(val) {
      if (val) this.generateQr()
    }
  },
  methods: {
    addProduct() {
      this.quotationForm.productList.push({
        productName: '', model: '', quantity: 1, unitPrice: '', remark: ''
      })
    },
    deleteProduct(index) {
      if (this.quotationForm.productList.length <= 1) {
        this.$message.warning('至少保留一条商品')
        return
      }
      this.quotationForm.productList.splice(index, 1)
    },
    resetForm() {
      this.$refs.quotationForm.resetFields()
      this.quotationForm.productList = [
        { productName: '', model: '', quantity: 1, unitPrice: '', remark: '' }
      ]
      this.quotationForm.remark = ''
    },
    printForm() {
      window.print()
    },
    submitForm() {
      this.$refs.quotationForm.validate(valid => {
        if (!valid) return
        const err = this.quotationForm.productList.some(i => !i.productName || !i.unitPrice)
        if (err) {
          this.$message.error('请填写完整商品名称和单价')
          return
        }
        if (!this.quotationForm.quoteNo) {
          this.quotationForm.quoteNo = 'QT' + Date.now()
        }
        this.$message.success('报价单生成成功！')
        this.mode = 'view'
      })
    },
    exportExcel() {
      const headers = ['产品名称', '型号', '数量', '单价(USD)', '总价(USD)', '备注']
      const data = [headers]
      this.quotationForm.productList.forEach(item => {
        data.push([
          item.productName,
          item.model,
          item.quantity,
          item.unitPrice,
          (item.quantity * item.unitPrice || 0).toFixed(2),
          item.remark
        ])
      })
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '报价单')
      XLSX.writeFile(wb, `报价单_${this.quotationForm.quoteNo || '未命名'}.xlsx`)
      this.$message.success('Excel导出成功')
    },
    exportPdf() {
      const opt = {
        margin: 10,
        filename: `报价单_${this.quotationForm.quoteNo || '未命名'}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }
      const el = document.querySelector('.form-page-container')
      html2pdf().set(opt).from(el).save().then(() => {
        this.$message.success('PDF导出成功')
      })
    },
    generateQr() {
      const text = JSON.stringify(this.quotationForm)
      QRCode.toCanvas(this.$refs.qrCanvas, text, { width: 200 }, err => {
        if (err) {
          this.$message.error('二维码生成失败')
          console.error(err)
        }
      })
    }
  }
}
</script>

<style scoped>
.form-page-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.page-header h2 {
  font-size: 22px;
  color: #333;
  margin: 0;
}
.tips {
  color: #999;
}
.btn-top-group {
  margin-bottom: 15px;
  text-align: right;
}
.form-card {
  border-radius: 8px;
}
.card-title {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-header {
  background: #f5f7fa !important;
}
.total-price {
  text-align: right;
  margin-top: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.num {
  color: #fa5515;
  font-size: 18px;
  margin-left: 5px;
}
.btn-box {
  margin-top: 30px;
  text-align: center;
}
.mt20 {
  margin-top: 20px;
}
.qr-box {
  text-align: center;
  padding: 20px 0;
}
</style>